import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraIconButton } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { Cross2Icon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { apiErrorMessage } from '../../../lib/api/apiErrorMessage';
import { useRecordDocumentMutations } from './hooks';
export function RecordDocumentUnlinkButton({ entity, artifactId, title }) {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState('');
    const { unlink } = useRecordDocumentMutations();
    const onOpenChange = (next)=>{
        if (unlink.isPending) return;
        setError('');
        setOpen(next);
    };
    const confirm = ()=>{
        if (unlink.isPending) return;
        setError('');
        unlink.mutate({
            entity,
            artifactId
        }, {
            onSuccess: ()=>setOpen(false),
            onError: (e)=>setError(apiErrorMessage(e, 'Could not unlink this document. Try again.'))
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraIconButton, {
                label: `Unlink ${title}`,
                variant: "ghost",
                size: "sm",
                "data-testid": Testids.registryDocuments.unlinkButton,
                onClick: ()=>setOpen(true),
                children: /*#__PURE__*/ _jsx(Cross2Icon, {})
            }),
            /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
                open: open,
                onOpenChange: onOpenChange,
                size: "sm",
                title: "Unlink this document?",
                footerProps: {
                    confirmLabel: 'Unlink',
                    loadingLabel: 'Unlinking…',
                    loading: unlink.isPending,
                    onConfirm: confirm,
                    onCancel: ()=>onOpenChange(false),
                    cancelProps: {
                        disabled: unlink.isPending
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "Unlink this document? The document itself is not deleted."
                    }),
                    error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                        tone: "danger",
                        children: error
                    })
                ]
            })
        ]
    });
}
